var map = {
	"./ban-cn/1.jpg": "m1fE",
	"./ban-cn/2.jpg": "G6os",
	"./ban-cn/3.jpg": "11Os",
	"./ban-cn/4.jpg": "n5Et",
	"./ban-cn/5.jpg": "d5iY",
	"./ban-cn/6.jpg": "96j0",
	"./ban-de/1.jpg": "qw56",
	"./ban-de/2.jpg": "MgLF",
	"./ban-de/3.jpg": "amaT",
	"./ban-de/4.jpg": "LGVd",
	"./ban-de/5.jpg": "Iv9g",
	"./ban-de/6.jpg": "Jzef",
	"./ban-en/1.jpg": "5W9C",
	"./ban-en/2.jpg": "ZWtP",
	"./ban-en/3.jpg": "YE9H",
	"./ban-en/4.jpg": "xSAD",
	"./ban-en/5.jpg": "DNpt",
	"./ban-en/6.jpg": "Sihr",
	"./ban-es/1.jpg": "MEdh",
	"./ban-es/2.jpg": "eAuL",
	"./ban-es/3.jpg": "fcHW",
	"./ban-es/4.jpg": "KqcB",
	"./ban-es/5.jpg": "iatu",
	"./ban-es/6.jpg": "FwPy",
	"./ban-fr/1.jpg": "bYg6",
	"./ban-fr/2.jpg": "zi9h",
	"./ban-fr/3.jpg": "XGT6",
	"./ban-fr/4.jpg": "mjUx",
	"./ban-fr/5.jpg": "FJvw",
	"./ban-fr/6.jpg": "OfNu",
	"./ban-pt/1.jpg": "5O8E",
	"./ban-pt/2.jpg": "6clr",
	"./ban-pt/3.jpg": "7ngJ",
	"./ban-pt/4.jpg": "ZChH",
	"./ban-pt/5.jpg": "14Nq",
	"./ban-pt/6.jpg": "0Abr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YW4s";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4 ^\.\/ban\-.*\.jpg$
// module id = YW4s
// module chunks = 1